/**
 * 360广告
 */
import reqwest from 'reqwest';
import util from '../util';
export default {
  _uid: false, // 360 uid 缓存
  _newuid: false, // 360 uid 缓存
  /**
   * 获取广告
   * @param params
   * @param callback
   */
  getAdsList (params, callback) {
    params = Object.assign({
      type: '1',
      of: '4',
      newf: '1',
      scheme: 'https',
      uid: this.getUID()
    }, params); // 和公共参数合并
    reqwest({
      url: 'https://show-g.mediav.com/s',
      data: params,
      type: 'jsonp',
      jsonpCallback: 'jsonp',
      timeout: 20000
    }).then(val => setTimeout(callback(null, val), 50)).catch(e => callback(e))
  },
  /**
   * 点击统计上报
   * @param obj
   */
  clickReport (arrReportUrls) {
    if (arrReportUrls.length > 0) {
      var self = this
      arrReportUrls.forEach(function (reportUrl) {
        self.doReport(reportUrl, (err, result) => {
          if (err) {
            self.debugLog('点击统计发送异常', reportUrl)
            self.debugLog(err)
          } else {
            self.debugLog('点击统计发送OK:' + reportUrl + ', ret:' + JSON.stringify(result))
          }
        })
      }, this)
    } else {
      self.debugLog('点击统计发送异常', arrReportUrls)
    }
  },
  /**
   * 展示统计上报
   * @param obj
   */
  showReport (arrReportUrls) {
    if (arrReportUrls.length > 0) {
      var self = this;
      arrReportUrls.forEach(function (reportUrl) {
        self.doReport(reportUrl, (err, result) => {
          if (err) {
            self.debugLog('展示统计发送异常:' + reportUrl)
          } else {
            self.debugLog('展示统计发送OK:' + reportUrl + ', result:' + JSON.stringify(result))
          }
        })
      })
    } else {
      self.debugLog('展示统计发送异常', arrReportUrls)
    }
  },
  /**
   * 发送上报请求
   * @param url
   * @param callback
   */
  doReport (url, callback) {
    if (document.getElementById(url) === null) {
      var img = document.createElement('img')
      img.setAttribute('src', url + '&_' + Math.random())
      img.setAttribute('id', url + '&_' + Math.random())
      img.style.cssText = 'display:none'
      if (!!document.getElementById('reportZone') === false) {
        let reportZone = document.createElement('div');
        reportZone.setAttribute('id', 'reportZone');
        document.body.appendChild(reportZone);
      }
      document.getElementById('reportZone').appendChild(img);
      if (document.all) {
        img.onreadystatechange = function () {
          if (/onload|loaded|complete/.test(img.readyState)) {
            callback(null, {msg: 'ok'})
            img.remove();
          }
        }
      } else {
        img.onload = function () {
          callback(null, {msg: 'ok'});
          img.remove();
        }
      }
      img.onerror = function () {
        callback(JSON.stringify(img))
      }
    } else {
      callback({msg: 'error: repeated', url: url})
    }
  },
  /**
   * 生成str的hash值
   * @param str
   * @returns {number}
   */
  getHash (str) {
    let hash = 1, charCode = 0;
    if (str) {
      hash = 0;
      for (var idx = str.length - 1; idx >= 0; idx--) {
        charCode = str.charCodeAt(idx)
        hash = (hash << 6 & 268435455) + charCode + (charCode << 14);
        charCode = hash & 266338304;
        hash = charCode !== 0 ? hash ^ charCode >> 21 : hash;
      }
    }
    return hash;
  },
  /**
   * 创建并生成uid
   * @returns {*}
   */
  getUID () {
    let type = (arguments.length >= 1 ? arguments[0] : 'left'), uid = '';
    if (type === 'left') {
      uid = this._uid
      if (!!uid === false) {
        let d = (new Date() - 0), s = window.location.href, hash = this.getHash(s);
        uid = '' + d + hash + Math.random() + Math.random() + Math.random() + Math.random()
        uid = uid.replace(/\./g, '').substring(0, 32)
        this._uid = uid
      }
    } else {
      uid = this._newuid;
      if (!!uid === false) {
        uid = util.getUUID() + this.getHash('2345.com');
        this._newuid = uid
      }
    }
    return uid
  },
  debugLog() {
    // console.log('ad 360', ...arguments);
  }
}
